/** Base64を復号する。標準関数がない環境ではBufferを使い、変換エラーは呼び出し元へ返す。 */
export function decodeBase64(value: string): string {
  if (typeof atob === "function") return atob(value);
  return Buffer.from(value, "base64").toString("utf8");
}

/** 文字列をBase64に変換する。標準関数がない環境ではBufferを使い、変換エラーは呼び出し元へ返す。 */
export function encodeBase64(value: string): string {
  if (typeof btoa === "function") return btoa(value);
  return Buffer.from(value, "utf8").toString("base64");
}
